export const getVatRateAmount = (unitPrice: number, vatRatePercent = 0): number => {
  const total = (unitPrice * vatRatePercent) / 100;

  return Math.round(total * 100) / 100;
};
